<template>
  <div class="tx-list-page">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="list-hero">
            <p class="list-crumb">Contabilidad / Pago de Impuestos</p>
            <h1 class="list-title">Pago de Impuestos</h1>
            <p class="list-subtitle">
              Trámites aprobados por los órganos anuentes. Registra el monto de
              impuestos y adjunta el comprobante de pago.
            </p>
          </div>
        </v-flex>

        <v-flex xs12>
          <tx-filter @search="onSearch" @download="onDownload"></tx-filter>
        </v-flex>

        <v-flex xs12>
          <v-card class="tx-card">
            <div class="tx-toolbar">
              <div class="tx-toolbar__info">
                <span class="tx-chip">
                  <v-icon small class="tx-chip__icon">request_quote</v-icon>
                  {{ meta.totalGroups }} trámites
                  <template v-if="meta.totalInvoices !== meta.totalGroups">
                    ({{ meta.totalInvoices }} facturas)
                  </template>
                </span>
                <span class="tx-chip tx-chip--danger">
                  <span class="light light--red"></span>
                  {{ pendientes }} pendientes
                </span>
                <span class="tx-chip tx-chip--accent">
                  <span class="light light--green"></span>
                  {{ realizados }} realizados
                </span>
              </div>
            </div>
            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <div class="table-wrap">
                <table class="tx-table">
                  <thead>
                    <tr>
                      <th class="th-center">Estado</th>
                      <th># Factura</th>
                      <th class="th-right">Monto CIF (USD)</th>
                      <th>Laboratorio</th>
                      <th>Distribuidor</th>
                      <th>Órganos Anuentes</th>
                      <th>Fecha de Aprobación</th>
                      <th class="th-right">Monto de Impuestos</th>
                      <th>Fecha de Pago</th>
                      <th class="th-center">Paga Transit</th>
                      <th class="th-actions">Comprobante</th>
                    </tr>
                  </thead>
                  <!-- Un <tbody> por trámite: la banda con el consecutivo y,
                       debajo, una fila por factura. Es el mismo patrón de
                       filas agrupadas de todas las listas de Transit
                       (tx-group-row), con el texto de la banda del mixin
                       TramiteBand; el grupo entero abre el diálogo. -->
                  <tbody
                    v-for="g in groups"
                    :key="g.key"
                    class="tx-group"
                    @click="openDocs(g.tramite)"
                  >
                    <tr
                      class="tx-group-row"
                      :class="{ 'tx-group-row--single': !esConsolidado(g) }"
                    >
                      <td colspan="11">
                        <v-icon small class="tx-group-row__icon">
                          {{ esConsolidado(g) ? 'layers' : 'description' }}
                        </v-icon>
                        {{ etiquetaTramite(g) }}
                        <strong>{{ consecutivoDe(g) }}</strong>
                        &middot; {{ facturasDe(g) }}
                        <span
                          v-if="esConsolidado(g)"
                          class="tx-group-row__muted"
                        >
                          &middot; CIF total {{ money(cifTramiteDe(g)) }}
                        </span>
                        <span v-if="controlFdDe(g)" class="tx-group-row__muted">
                          &middot; Control F&amp;D: {{ controlFdDe(g) }}
                        </span>
                      </td>
                    </tr>

                    <!-- Una fila por factura. Lo que es del TRÁMITE (semáforo,
                         órganos, fechas, monto, switch y comprobante) va una
                         sola vez, en la primera fila, y abarca las demás con
                         rowspan: así nada se repite. -->
                    <tr
                      v-for="(inv, i) in g.invoices"
                      :key="inv.id"
                      :class="{ 'tx-child-row': esConsolidado(g) }"
                    >
                      <!-- Semáforo: rojo mientras no haya fecha de pago -->
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-center"
                      >
                        <v-tooltip bottom>
                          <template slot="activator">
                            <span
                              class="light"
                              :class="
                                g.tramite.taxPaidDate
                                  ? 'light--green'
                                  : 'light--red'
                              "
                            ></span>
                          </template>
                          <span>
                            {{
                              g.tramite.taxPaidDate
                                ? 'Realizado: el impuesto ya fue pagado'
                                : 'Pendiente: falta el pago del impuesto'
                            }}
                          </span>
                        </v-tooltip>
                      </td>
                      <td class="tx-cell--strong tx-cell--factura">
                        {{ inv.invoiceNumber || '—' }}
                      </td>
                      <td class="th-right tx-nowrap">{{ money(inv.cif) }}</td>
                      <td>{{ inv.laboratorio || '—' }}</td>
                      <td>{{ inv.distribuidor || '—' }}</td>
                      <td v-if="i === 0" :rowspan="g.invoices.length">
                        <div
                          v-if="
                            g.tramite.organosAnuentes &&
                              g.tramite.organosAnuentes.length
                          "
                          class="organo-list"
                        >
                          <span
                            v-for="o in g.tramite.organosAnuentes"
                            :key="o.id"
                            class="organo-tag"
                          >
                            {{ o.name }}
                          </span>
                        </div>
                        <span v-else class="tx-muted">—</span>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="tx-nowrap"
                      >
                        {{ dateOf(g.tramite.departureDate) }}
                      </td>
                      <!-- El monto se escribe en el mismo diálogo donde se
                           adjunta el comprobante: es un solo acto y el cliente
                           lo pidió así. El botón está a la vista porque no
                           encontraba el diálogo que abre la fila. -->
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-right tx-nowrap"
                        @click.stop
                      >
                        <v-tooltip bottom>
                          <template slot="activator">
                            <button
                              class="amt-btn"
                              :class="{
                                'amt-btn--empty': !g.tramite.taxAmount,
                              }"
                              @click="openDocs(g.tramite)"
                            >
                              <span v-if="g.tramite.taxAmount">{{
                                money(g.tramite.taxAmount)
                              }}</span>
                              <span v-else>Poner monto</span>
                              <v-icon small class="amt-btn__icon">edit</v-icon>
                            </button>
                          </template>
                          <span>
                            {{
                              g.tramite.taxAmount
                                ? 'Cambiar el monto del pago de impuestos'
                                : 'Registrar el monto que se pagó a la aduana por este trámite'
                            }}
                          </span>
                        </v-tooltip>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="tx-nowrap"
                      >
                        <span v-if="g.tramite.taxPaidDate">{{
                          dateOf(g.tramite.taxPaidDate)
                        }}</span>
                        <span
                          v-else
                          class="tx-muted"
                          title="Se fija sola al cargar el comprobante"
                        >
                          Al cargar comprobante
                        </span>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-center"
                        @click.stop
                      >
                        <v-tooltip bottom>
                          <template slot="activator">
                            <v-switch
                              :input-value="g.tramite.taxPaidByTransit"
                              color="#254f87"
                              class="tx-switch"
                              hide-details
                              @change="toggleTransitPays(g.tramite)"
                            ></v-switch>
                          </template>
                          <span>
                            {{
                              g.tramite.taxPaidByTransit
                                ? 'Transit adelanta el impuesto y se lo cobra al cliente'
                                : 'El cliente paga directo; no entra al estado de cuenta'
                            }}
                          </span>
                        </v-tooltip>
                      </td>
                      <td
                        v-if="i === 0"
                        :rowspan="g.invoices.length"
                        class="th-actions"
                        @click.stop
                      >
                        <v-tooltip bottom>
                          <template slot="activator">
                            <button
                              class="doc-btn"
                              :class="{
                                'doc-btn--done': docCount(g.tramite) > 0,
                              }"
                              @click="openDocs(g.tramite)"
                            >
                              <v-icon small>attach_file</v-icon>
                              {{
                                docCount(g.tramite)
                                  ? 'Comprobantes'
                                  : 'Adjuntar'
                              }}
                              <span
                                v-if="docCount(g.tramite)"
                                class="doc-btn__count"
                              >
                                {{ docCount(g.tramite) }}
                              </span>
                            </button>
                          </template>
                          <span>
                            {{
                              docCount(g.tramite)
                                ? 'Ver, agregar, reemplazar o eliminar comprobantes'
                                : 'Adjuntar el comprobante de pago. Al cargarlo se registra la fecha'
                            }}
                          </span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-if="!pagination.loading && groups.length === 0">
                    <tr>
                      <td colspan="11" class="empty-state">
                        No hay trámites aprobados con los filtros aplicados.
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="pagination.loading">
                    <tr>
                      <td colspan="11" class="empty-state">Cargando...</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 v-if="pagination.pages">
          <div class="list-footer">
            <div class="list-footer__count">
              Mostrando {{ groups.length }} de {{ meta.totalGroups }} trámites
              ({{ meta.totalInvoices }}
              facturas)
            </div>
            <v-pagination
              v-model="pagination.page"
              :length="pagination.pages"
              :total-visible="7"
              color="#254f87"
              @input="asyncPagination"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="720" v-if="docs.data" v-model="docs.show">
      <tax-docs
        :key="docs.key"
        :item="docs.data"
        v-on:close-docs="docs.show = false"
        v-on:save-docs="onDocsSaved"
      ></tax-docs>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>

    <v-snackbar
      v-model="snack.show"
      :timeout="4000"
      :color="snack.color"
      right
      top
    >
      {{ snack.message }}
      <v-btn flat dark @click="snack.show = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import loading from './../dialog/DialogLoading'
import taxDocs from './../dialog/DialogTaxDocuments'
import TxFilter from './../transit/TransitFilter.vue'
import TramiteBand from './../transit/mixins/TramiteBand'
import SessionHelper from '@/helpers/SessionHelper'

export default {
  components: {
    loading,
    'tax-docs': taxDocs,
    'tx-filter': TxFilter,
  },
  // Banda del trámite y money(): la misma fuente que Facturas y Transit.
  mixins: [TramiteBand],
  data() {
    return {
      loading: true,
      // El backend agrupa por consolidado, igual que el resto de Transit.
      groups: [],
      meta: { totalGroups: 0, totalInvoices: 0, totalDone: 0 },
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      docs: { show: null, data: null, key: 0 },
      // Comprobantes por factura, para el contador del botón.
      docCounts: {},
      snack: { show: false, color: 'info', message: '' },
    }
  },
  created() {
    this.asyncPagination()
  },
  computed: {
    // Una fila por TRÁMITE: la fila padre del consolidado (con el CIF sumado)
    // o la factura sola. Es lo que contabilidad cobra.
    tramites() {
      return this.groups.map(g => g.tramite).filter(Boolean)
    },
    invoices() {
      return this.tramites
    },
    pageIds() {
      return this.invoices.map(item => item.id)
    },
    // Semáforos de TODO el filtro, no de la página: la API los cuenta sobre
    // el listado completo. Antes se contaban las filas cargadas y con 800
    // trámites sin pagar el chip decía 25.
    realizados() {
      return this.meta.totalDone
    },
    pendientes() {
      return Math.max(0, this.meta.totalGroups - this.meta.totalDone)
    },
  },
  methods: {
    dateOf(value) {
      return value ? moment(value).format('DD/MM/YYYY') : '—'
    },
    docCount(item) {
      return this.docCounts[item.id] || 0
    },
    notify(message, color = 'info') {
      this.snack = { show: true, color, message }
    },
    helperPaginate(response) {
      this.groups = (response && response.groups) || []
      this.meta = {
        totalGroups: (response && response.totalGroups) || 0,
        totalInvoices: (response && response.totalInvoices) || 0,
        totalDone: (response && response.totalDone) || 0,
      }
      // Se pagina por GRUPO: un consolidado no queda partido entre páginas.
      this.pagination.totalItems = this.meta.totalInvoices
      this.pagination.pages =
        Math.ceil(this.meta.totalGroups / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
      this.loadDocCounts()
    },
    loadDocCounts() {
      if (!this.pageIds.length) {
        this.docCounts = {}
        return
      }
      this.$store
        .dispatch('invoices/getDocuments', {
          ids: this.pageIds.join(','),
          step: 'PAYED',
        })
        .then(docs => {
          const counts = {}
          ;(docs || []).forEach(d => {
            counts[d.invoiceId] = (counts[d.invoiceId] || 0) + 1
          })
          this.docCounts = counts
        })
    },
    asyncPagination() {
      this.pagination.loading = true
      const filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        status: 'accounting',
        ...this.pagination.search,
      }
      return new Promise(resolve => {
        this.$store
          .dispatch('invoices/getConsolidated', filter)
          .then(response => {
            this.helperPaginate(response)
            return resolve()
          })
      })
    },
    // El switch decide si el monto entra al estado de cuenta.
    toggleTransitPays(item) {
      const next = !item.taxPaidByTransit
      item.taxPaidByTransit = next
      this.$store
        .dispatch('invoices/updateAccounting', {
          invoiceId: item.id,
          taxPaidByTransit: next,
        })
        .then(response => {
          if (!response || (response.status && response.status >= 400)) {
            item.taxPaidByTransit = !next
            this.notify('No se pudo actualizar el switch.', 'error')
            return
          }
          this.notify(
            next
              ? 'Transit adelanta el impuesto; entra al estado de cuenta.'
              : 'El cliente paga directo; queda fuera del estado de cuenta.',
            'success'
          )
        })
        .catch(() => {
          item.taxPaidByTransit = !next
          this.notify('No se pudo actualizar el switch.', 'error')
        })
    },
    // El monto y el comprobante son del trámite: en un consolidado van UNA
    // vez, a la fila padre, aunque tenga diez facturas. El diálogo escribe el
    // monto además de los archivos, así que se le pasa lo que ya hay.
    openDocs(t) {
      this.docs = {
        data: {
          invoices: [t.id],
          invoiceNumber: t.consolidated ? null : t.invoiceNumber,
          code: t.consolidated ? t.internalNumber || t.fdcontrolNumber : null,
          count: (t.facturas || []).length,
          taxAmount: t.taxAmount,
          taxPaidDate: t.taxPaidDate,
        },
        show: true,
        key: this.docs.key + 1,
      }
    },
    onDocsSaved() {
      this.docs.show = false
      this.loading = true
      this.asyncPagination().then(() => {
        this.notify('Trámite actualizado.', 'success')
      })
    },
    onSearch(params) {
      Object.keys(params).forEach(key => {
        if (params[key] == null || params[key] === '') delete params[key]
      })
      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        status: 'accounting',
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
  },
}
</script>

<style scoped src="./../transit/transit-list.css"></style>

<style scoped>
/* Semáforo: el estado del pago se lee de un vistazo, sin leer la fecha.
   Rojo = pendiente, verde = realizado. */
.light {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  vertical-align: middle;
}
.light--red {
  background: #dc2626;
  box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.18);
}
.light--green {
  background: #15803d;
  box-shadow: 0 0 0 3px rgba(21, 128, 61, 0.18);
}
.tx-chip--danger {
  background: rgba(220, 38, 38, 0.12);
  color: #991b1b;
}

/* El grupo entero (banda + facturas) abre el diálogo del trámite. El realce
   conjunto del grupo viene de transit-list.css. */
.tx-group {
  cursor: pointer;
}

/* Montos editables en línea, discretos hasta que reciben foco. */
.amount {
  width: 110px;
  text-align: right;
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 5px 8px;
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  color: #0f172a;
  background: #f8fafc;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.amount:hover {
  border-color: #e2e8f0;
  background: #ffffff;
}
.amount:focus {
  outline: none;
  border-color: #254f87;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(37, 79, 135, 0.12);
}
.amount::placeholder {
  color: #cbd5e1;
}

.tx-switch {
  margin: 0 !important;
  padding: 0 !important;
}

/* Botón de comprobantes: cambia de tono cuando ya hay documentos. */
.doc-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #475569;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.18s ease;
}
.doc-btn .v-icon {
  color: #64748b !important;
  font-size: 15px !important;
}
.doc-btn:hover {
  background: #f1f5f9;
  border-color: #94a3b8;
}
.doc-btn--done {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #15803d;
}
.doc-btn--done .v-icon {
  color: #15803d !important;
}
.doc-btn--done:hover {
  background: #dcfce7;
  border-color: #86efac;
}
.doc-btn__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #dcfce7;
  font-size: 11px;
  font-weight: 700;
}
/* En Transit la sangría del consolidado va en la primera celda, que es la
   factura; aquí la primera es el semáforo y abarca todo el grupo, así que
   la sangría pasa a la celda de la factura. La regla de la factura se repite
   aunque ya esté en transit-list.css porque debe ir DESPUÉS de anular la
   primera celda: desde la segunda fila el semáforo (rowspan) no está y la
   factura es la primera celda. */
.tx-child-row td:first-child {
  padding-left: 14px;
  border-left: 0;
}
.tx-child-row td.tx-cell--factura {
  padding-left: 22px;
  border-left: 3px solid #cbd5e1;
}
/* El monto de impuestos se edita desde la fila. Con monto es un botón
   discreto con el valor; sin monto, una llamada a la acción. */
.amt-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 30px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #0f172a;
  font-size: 14px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  white-space: nowrap;
}
.amt-btn:hover {
  border-color: #254f87;
  background: #f1f5f9;
}
.amt-btn--empty {
  border-style: dashed;
  border-color: #dc2626;
  color: #991b1b;
  background: rgba(220, 38, 38, 0.06);
}
.amt-btn__icon {
  font-size: 15px !important;
  color: #64748b;
}
</style>
